import React, { useState, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast } from "react-hot-toast";
import { useNavigate, Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

import Header from "../../HomePage/Header/Header";
import Footer from "../../HomePage/Footer/Footer";
import FeedbackForm from "../../FeedbackForm/FeedbackForm";
import HourglassLoader from "../../../Common/HourglassLoader";

const host = process.env.REACT_APP_API_SERVER;
const siteKey = process.env.REACT_APP_SITE_KEY;

const StudentLogin = () => {
  const navigate = useNavigate();
  const captchaRef = useRef(null);

  const [captchaToken, setCaptchaToken] = useState(null);
  const [captchaError, setCaptchaError] = useState("");
  const [faIcon, setfaIcon] = useState("fa-eye-slash");

  const togglePasswordType = () => {
    let input_pass = document.getElementById("password-field");
    let input_type = input_pass.getAttribute("type");
    if (input_type === "password") {
      setfaIcon("fa-eye");
      input_pass.type = "text";
    } else {
      setfaIcon("fa-eye-slash");
      input_pass.type = "password";
    }
  };

  const formik = useFormik({
    initialValues: {
      emailMob: "",
      password: "",
      user_type: "student",
    },
    validationSchema: Yup.object({
      emailMob: Yup.string()
        .required("Email is required")
        .email("Enter valid email"),
      password: Yup.string().required("Password is required"),
    }),
   // StudentLogin.jsx (Nayi file)
onSubmit: async (values, { setSubmitting, resetForm }) => {
    try {
        if (!captchaToken) {
            setCaptchaError("Please complete the CAPTCHA.");
            return;
        }
        setSubmitting(true);

        const response = await axios.post(`${host}/api/web/student-sign-in`, {
            ...values,
            captchaToken,
        });

        if (response.status === 200) {
            setSubmitting(false);
            toast.success("Signed In Successfully");
            resetForm();
            localStorage.removeItem("tutor-token");
            localStorage.setItem("student-token", response.data.token);
            
            await axios.get(`${host}/api/web/change-online-status?status=1`, {
                headers: {
                    "x-auth-token": response.data.token  
                }
            });

            navigate("/student");
        } else {
            // error handling
        }
    } catch (error) {
        // error handling
    }
}
  });

  const handleCaptcha = (token) => {
    setCaptchaToken(token);
    setCaptchaError("");
  };

  return (
    <>
      <FeedbackForm />
      <Header />

      {/* Using exactly the same background classes */}
      <div className="login-background">
        <div className="login-main-container login-main-container-two">
          <div className="row login-form-part">
            <div className="card login-form" style={{ maxWidth: "500px", margin: "0 auto" }}>
              <div className="form-body pt-4">
                <form onSubmit={formik.handleSubmit}>
                  <h4 className="text-center mb-4 fw-bold">Student Login</h4>

                  {/* Email Field - with register page styling */}
                  <div className="mb-3">
                    <label htmlFor="emailMob" className="form-label">
                      Email<span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      name="emailMob"
                      id="emailMob"
                      placeholder="Enter Your Email"
                      className="input-form"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.emailMob}
                    />
                    <div className="help-block with-errors">
                      {formik.touched.emailMob && formik.errors.emailMob && (
                        <div className="text-danger mt-1">
                          {formik.errors.emailMob}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Password Field - with toggle icon like register page */}
                  <div className="mb-3">
                    <label htmlFor="password-field" className="form-label">
                      Password<span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <input
                        placeholder="Enter Your Password"
                        id="password-field"
                        type="password"
                        className="input-form"
                        name="password"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.password}
                      />
                      <i
                        toggle="#password-field"
                        className={`fa-regular ${faIcon} field-icon toggle-password`}
                        id="toggle_pass"
                        onClick={togglePasswordType}
                      />
                    </div>
                    <div className="help-block with-errors">
                      {formik.touched.password && formik.errors.password && (
                        <div className="text-danger mt-1">
                          {formik.errors.password}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Forgot Password Link */}
                  <div className="mb-3 text-end">
                    <Link
                      to="/forget-password"
                      className="text-primary text-decoration-underline"
                      style={{ fontSize: 14 }}
                    >
                      Forgot Your Password?
                    </Link>
                  </div>

                  {/* Recaptcha */}
                  <div className="mb-3">
                    <ReCAPTCHA
                      sitekey={siteKey}
                      onChange={handleCaptcha}
                      ref={captchaRef}
                    />
                    {captchaError && (
                      <div className="text-danger mt-2">{captchaError}</div>
                    )}
                  </div>

                  {/* Submit Button - exactly like register page */}
                  <div className="mb-3 row">
                    <div className="col-sm-12 mb-3 text-center">
                      <button
                        type="submit"
                        disabled={formik.isSubmitting}
                        className="login-btn fw-bold"
                        style={{ color: "white !important" }}
                      >
                        {formik.isSubmitting ? <HourglassLoader /> : "Login"}
                      </button>
                    </div>
                  </div>

                  {/* Register Link - exactly like register page */}
                  <div className="log-undre-text text-center my-2">
                    <p>
                      Not registered yet?
                      <Link to="/student/register">
                        <span> Register</span>
                      </Link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default StudentLogin;